import { render, staticRenderFns } from "./post-job.vue?vue&type=template&id=70ac0f9e&scoped=true"
import script from "./post-job.vue?vue&type=script&lang=js"
export * from "./post-job.vue?vue&type=script&lang=js"
import style0 from "./post-job.vue?vue&type=style&index=0&id=70ac0f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac0f9e",
  null
  
)

export default component.exports